/**
 * GameShellContext — React context exposant le `GameRunController` aux hooks.
 *
 * Source : DEC-005 §pattern-unifié.
 *
 * Pattern : `<GameShell>` (L3 components) crée le controller et le push dans ce
 * context. Les hooks `useGameShell`, `useGamePhase`, `useGameBus` lisent depuis là.
 *
 * Pour usage standalone sans provider, `useGameShell(opts)` peut aussi créer son
 * propre controller (cf. signature dual-mode).
 */
import { createContext } from 'react';
export const GameShellContext = createContext(null);
GameShellContext.displayName = 'GameShellContext';
//# sourceMappingURL=context.js.map